import session from '@/shared/session'
import axios from "axios";

// initial state
const state = {
	current : {},
}

// getters
const getters = {}

// actions
const actions = {
	staffOverview ({},data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/users/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	membersOverview ({},data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/users/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	userDetail ({},data) {
		return new Promise((resolve, reject) => {
			axios.get(`/api/auth/users/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	userCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			axios.post('api/auth/register/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	notificationCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			axios.post('api/auth/notification-create/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	userUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			axios.put(`/api/auth/update-user/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	userRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			axios.patch(`/api/auth/users/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterStaff ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/users/get_filtered_staff/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	joinedThisMonth ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/users/get_members_joined_this_month/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	getNotifications ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/notifications/get_notifications', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)
				console.log("hier")

			}).catch(errors => {
				resolve(errors.response.data)
				console.log("hierenn")
			})
		})
	},
	filterMembers ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/users/get_filtered_members/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	filter_users ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/users/filter_users/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	filterMembership ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.get('/api/auth/memberships/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    userStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.patch(`/api/auth/users/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	renewMembership ({ commit }, data) {
		return new Promise((resolve, reject) => {console.log(data)
			axios.post(`/api/auth/memberships/${data.id}/renew_membership/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	bulkRenewMembership ({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/api/auth/memberships/bulk_renew_membership/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
